import React, { Component } from "react";
import {FaTwitter ,FaInstagram ,FaFacebookF , FaLinkedinIn, FaYoutube} from "react-icons/fa";

const SocialShare = [
    {Social: <FaYoutube /> , link: 'https://www.youtube.com/channel/UCCw3NXHfO7VuIXRIfKvfcPQ?view_as=subscriber'},
    {Social: <FaFacebookF /> , link: 'https://www.facebook.com/codehunterss'},
    {Social: <FaLinkedinIn /> , link: 'https://www.linkedin.com/in/code-hunters-b0b4841bb/'},
    {Social: <FaInstagram /> , link: 'https://www.instagram.com/code__hunters/'},
    {Social: <FaTwitter /> , link: 'https://twitter.com/CodeHuntets'},
]

class Footer extends Component{
    render(){
        return(
            <React.Fragment>
                <footer className="footer-area">
                    <div className="footer-wrapper">
                        <div className="row align-items-end row--0">
                            <div className="col-lg-6">
                                <div className="footer-left">
                                    <div className="inner">
                                        <span>Ready To Do This</span><br/>
                                        <h2>Grow your <br /> Business</h2>
                                        <a className="rn-button-style--2" href="/contact">
                                            <span>Contact Us</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="footer-right" data-black-overlay="6">
                                    <div className="row">
                                        {/* Start Single Widget  */}
                                        <div className="col-lg-6 col-sm-6 col-12">
                                            <div className="footer-link">
                                                <h4>&nbsp;Quick Link</h4>
                                                <ul className="ft-link">
                                                    <li><a href="/web-development">Web Development</a></li>
                                                    <li><a href="/mobile-app-development">App Development</a></li>
                                                    <li><a href="/digital-marketing">Digital Marketing</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                        {/* End Single Widget  */}
                                        {/* Start Single Widget  */}
                                        <div className="col-lg-6 col-sm-6 col-12 mt_mobile--30">
                                            <div className="footer-link">
                                                <h4>&nbsp; Say Hello</h4>
                                                <ul className="ft-link">
                                                    <li><a href="tel:+91 9095241578">+91 9095241578</a></li>
                                                    <li><a href="mailto:codehunters2020@gmail.com">codehunters2020@gmail.com</a></li>
                                                    <li><a href="mailto:support@codehunters.co.in">support@codehunters.co.in</a></li>
                                                </ul>

                                                <div className="social-share-inner">
                                                    <ul className="social-share social-style--2 d-flex justify-content-start liststyle mt--15">
                                                        {SocialShare.map((val , i) => (
                                                            <li key={i}><a href={`${val.link}`}>{val.Social}</a></li>
                                                        ))}
                                                    </ul>
                                                </div> 
                                            </div>
                                        </div>
                                        {/* End Single Widget  */}

                                        <div className="col-lg-12">
                                            <div className="copyright-text">
                                                <p>Copyright © 2020 - <a href="https://www.codehunters.co.in">CODEHUNTERS</a>. All Rights Reserved.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
            </React.Fragment>
        )
    }
}
export default Footer;